import * as React from 'react'

import { Timer, WaitAndReloadComponentProps } from './types'

export const WaitAndReload: React.FC<WaitAndReloadComponentProps> = ({ children, time }) => {
    React.useEffect(() => {
        const timeoutID: Timer = setTimeout(() => window.location.reload(), time)
        return () => clearTimeout(timeoutID)
    }, [time])

    return children
}

export default React.memo(WaitAndReload)
